import { NotFoundError } from './not-found-error';

export class SlugInvalidError extends NotFoundError {}
